/** A multi-select's Select All row, told apart from real options by a value no option uses. */
export const SELECT_ALL_OPTION = { value: '__dime_select_all__', label: 'Select All' } as const;
